document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('CustomInquiryModal');
  if (!modal) return;

  var FORM_ID = 'jcz4ud6dv9n'; // Forminit Form ID
  var forminit = window.Forminit ? new Forminit() : null;

  var form = document.getElementById('CustomInquiryForm');
  var serviceField = document.getElementById('InquiryServiceTypeField');
  var titleEl = document.getElementById('InquiryModalTitle');
  var successMsg = document.getElementById('InquirySuccessMsg');
  var errorMsg = document.getElementById('InquiryErrorMsg');
  var submitBtn = form.querySelector('.inquiry-submit-btn');
  var btnLabel = submitBtn.querySelector('.btn-label');
  var btnSpinner = submitBtn.querySelector('.btn-spinner');

  var triggers = document.querySelectorAll('.inquiry-trigger-btn');
  var closeEls = modal.querySelectorAll('[data-close-modal]');
  var serviceGroupEls = modal.querySelectorAll('[data-service-group]');

  function showFieldsForService(service) {
    serviceGroupEls.forEach(function (el) {
      var groups = (el.getAttribute('data-service-group') || '')
        .split(',')
        .map(function (s) { return s.trim(); });
      var show = groups.indexOf(service) !== -1;
      el.style.display = show ? '' : 'none';
      el.querySelectorAll('input, select, textarea').forEach(function (field) {
        field.disabled = !show;
      });
    });
  }

  function openModal(service) {
    serviceField.value = service;
    titleEl.textContent = service + ' Inquiry';
    showFieldsForService(service);
    successMsg.style.display = 'none';
    errorMsg.style.display = 'none';
    form.style.display = '';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  triggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      openModal(btn.getAttribute('data-service'));
    });
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Toggle "Retail Store/Partner" only fields (e.g. Store Name) based on Customer Type radio
  var customerTypeRadios = modal.querySelectorAll('input[name="fi-radio-customerType"]');
  var retailOnlyFields = modal.querySelectorAll('[data-field-for="Retail Store/Partner"]');

  function toggleCustomerTypeFields() {
    var selected = modal.querySelector('input[name="fi-radio-customerType"]:checked');
    var value = selected ? selected.value : '';
    retailOnlyFields.forEach(function (el) {
      var show = value === 'Retail Store/Partner';
      el.style.display = show ? 'block' : 'none';
      el.querySelectorAll('input').forEach(function (f) { f.disabled = !show; });
    });
  }

  customerTypeRadios.forEach(function (radio) {
    radio.addEventListener('change', toggleCustomerTypeFields);
  });

  toggleCustomerTypeFields();

  // ===== Submit via Forminit (free plan, supports file uploads) =====
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    successMsg.style.display = 'none';
    errorMsg.style.display = 'none';

    if (!forminit) {
      errorMsg.textContent = 'Form service failed to load. Please refresh and try again.';
      errorMsg.style.display = '';
      return;
    }

    btnLabel.style.display = 'none';
    btnSpinner.style.display = '';
    submitBtn.disabled = true;

    var formData = new FormData(form);

    forminit.submit(FORM_ID, formData)
      .then(function (result) {
        btnLabel.style.display = '';
        btnSpinner.style.display = 'none';
        submitBtn.disabled = false;

        if (result.error) {
          errorMsg.textContent = result.error.message || 'Something went wrong. Please try again.';
          errorMsg.style.display = '';
          return;
        }

        form.style.display = 'none';
        successMsg.style.display = '';
      })
      .catch(function () {
        btnLabel.style.display = '';
        btnSpinner.style.display = 'none';
        submitBtn.disabled = false;
        errorMsg.style.display = '';
      });
  });
});